import type { SpotifyAlbumInfoResponse, SpotifyTrackItem } from "@/features/songs/album/types/spotify";

// ---------------------------------------------------------------------------
// Backend DTO shapes (camelCase from .NET JSON serialisation)
// ---------------------------------------------------------------------------

export type BackendArtistSummary = {
  id: string;
  name: string;
  spotifyUrl: string | null;
};

export type BackendTrackSummary = {
  id: string;
  name: string;
  durationMs: number | null;
  trackNumber: number | null;
  discNumber: number | null;
  isrc: string | null;
  spotifyUrl: string | null;
  artists: BackendArtistSummary[];
};

export type BackendAlbum = {
  id: string;
  name: string;
  releaseDate: string | null;
  totalTracks: number | null;
  images: { url: string; height: number | null; width: number | null }[];
  spotifyUrl: string | null;
  label: string | null;
  tracks: BackendTrackSummary[];
};

export type BackendAlbumResponse = { album: BackendAlbum };

// ---------------------------------------------------------------------------
// Mapper functions — backend DTO → legacy snake_case Spotify shapes
// ---------------------------------------------------------------------------

export function mapBackendTrack(track: BackendTrackSummary): SpotifyTrackItem {
  return {
    id: track.id,
    name: track.name,
    artists: (track.artists ?? []).map(a => ({
      id: a.id,
      name: a.name,
      external_urls: a.spotifyUrl != null ? { spotify: a.spotifyUrl } : undefined,
    })),
    duration_ms: track.durationMs ?? 0,
    track_number: track.trackNumber ?? 0,
    disc_number: track.discNumber ?? undefined,
    external_ids: track.isrc != null ? { isrc: track.isrc } : undefined,
    external_urls: track.spotifyUrl != null ? { spotify: track.spotifyUrl } : undefined,
  };
}

export function mapBackendAlbum(album: BackendAlbum): SpotifyAlbumInfoResponse {
  return {
    id: album.id,
    name: album.name,
    artists: [],
    images: album.images,
    release_date: album.releaseDate ?? undefined,
    total_tracks: album.totalTracks ?? undefined,
    label: album.label ?? undefined,
    external_urls: album.spotifyUrl != null ? { spotify: album.spotifyUrl } : undefined,
  };
}
